/**
 * The portal's sections, at runtime — the type is derived from it, so a section cannot exist without being
 * on this list, which is what `activity/screens.coverage.test.js` holds to a screen code (ADR 0012 step 29).
 */
export const PORTAL_VIEWS = ['home', 'leaderboards', 'fantasy', 'ratings', 'stats'] as const;

export type PortalView = (typeof PORTAL_VIEWS)[number];

/**
 * What each section is called on screen.
 *
 * **`ratings` means the real feature, and the label and the key finally say the same thing.** The
 * portal carried a ratings section until Phase 4b, and it was the legacy `RatingGroup` — tag-filtered
 * participation with no scoring at all — labelled *Tag groups* precisely so that one word would not
 * mean two different features to two different audiences: an operator's *Ratings* that scored, and a
 * player's that did not. §13 retired that entity, the section went with it, and Phase 7 widened
 * `/api/rating-boards`' published reads to §4.7's `Players` and `Public` audiences, which is what
 * makes this a section rather than a tab that 403s.
 *
 * It is gated on the room's `canRatings` in `PortalShell`, like the other two optional sections —
 * which is also where the **order** of the menu is decided. The sequence here is kept in step with
 * it so the file cannot be read as setting an order it does not set.
 */
export const VIEW_LABEL: Record<PortalView, string> = {
  home: 'Home',
  leaderboards: 'Leaderboards',
  fantasy: 'Fantasy',
  ratings: 'Ratings',
  stats: 'My stats',
};
